'use client'
import debounce from 'lodash/debounce'
import { useEffect, useState } from 'react'

const useWindowSize = () => {
  const [currentSize, setCurrentSize] = useState<number>(1366)

  useEffect(() => {
    const handleResize = () => setCurrentSize(window.innerWidth)
    const debouncedFunc = debounce(handleResize, 100)
    window.addEventListener('resize', debouncedFunc)
    handleResize()
    return () => window.removeEventListener('resize', debouncedFunc)
  }, [])

  return { currentSize }
}

export default useWindowSize
